import React, { createContext, useReducer } from 'react';

const getLocalStorage = (key) => {
  let data = window.localStorage.getItem('storeStm') || null;
  data = JSON.parse(data);
  if (!data) return null;
  return key in data ? data[key] : null;
};

const setLocalStorage = (key, value) => {
  let data = window.localStorage.getItem('storeStm') || null;
  data = JSON.parse(data) || {};
  data[key] = value;
  window.localStorage.setItem('storeStm', JSON.stringify(data));
};

/* AUTH CONTEXT */
const AuthContext = createContext();
const auth = getLocalStorage('auth');
const initialState = { ...auth };

const authReducer = (authState, action) => {
  let data = {};
  switch (action.type) {
    case 'set':
      setLocalStorage('auth', {
        ...authState,
        ...action.payload,
      });
      data = {
        ...authState,
        ...action.payload,
      };
      break;
    case 'get':
      data = { ...authState };
      break;
    case 'del':
      localStorage.removeItem('store');
      break;
    default:
      break;
  }

  return data;
};

const AuthContextProvider = (props) => {
  const setNewLocationFn = props.setNewLocation;
  const authProps = { ...props };
  const [authState, dispatch] = useReducer(authReducer, initialState);
  const value = { authState, dispatch, setNewLocationFn };
  return <AuthContext.Provider value={value}>{authProps ? authProps.children : null}</AuthContext.Provider>;
};

export { AuthContext, AuthContextProvider, getLocalStorage, setLocalStorage };
